module.exports = __webpack_public_path__ + "img/1992pigc.59c5332d.png";